// eslint-disable-next-line import/prefer-default-export

export const DAYS_TO_SHOW = 5;

export const CURRENT_LOCATION = {
  id: 0,
  description: 'Ubicación actual'
};

export const CITIES = [
  {
    id: 3427761,
    description: 'Tigre, Provincia de Buenos Aires',
    latitude: -34.426,
    longitude: -58.5796
  },
  {
    id: 3836564,
    description: 'San Salvador de Jujuy, Jujuy, Argentina',
    latitude: -24.1853,
    longitude: -65.2995
  },
  {
    id: 3833367,
    description: 'Ushuaia, Tierra del Fuego',
    latitude: -54.8,
    longitude: -68.3
  },
  {
    id: 3429886,
    description: 'Posadas, Misiones',
    latitude: -27.3671,
    longitude: -55.8961
  },
  {
    id: 3844421,
    description: 'Mendoza, Capital, Mendoza',
    latitude: -32.8897,
    longitude: -68.8443
  }
];
